import { Inject, Injectable } from '@angular/core';
import { FrattaleService } from './frattale.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CrossoverService extends FrattaleService {

  constructor(@Inject(HttpClient) protected http: HttpClient) { 
    super(http) 
  }

  lista(){
    let data = {
      action: "crossover/crossover_bt",
      cmd: "lista"
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  market(market: string){
    let data = {
      action: "crossover/crossover_bt",
      cmd: "market",
      market: market
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  lista_m15(mkt: string){
    let mkt1 = mkt.substring(0,3)
    let mkt2 = mkt.substring(3,6)
    let data = {
      action: "crossover/crossover_bt",
      cmd: "lista_m15",
      mkt1: mkt1,
      mkt2: mkt2
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  lista_h1(mkt: string){
    let mkt1 = mkt.substring(0,3)
    let mkt2 = mkt.substring(3,6)
    let data = {
      action: "crossover/crossover_bt",
      cmd: "lista_h1",
      mkt1: mkt1,
      mkt2: mkt2
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  ultimoOrarioH1(){
    let data = {
      action: "crossover/crossover_bt",
      cmd: "ultimo_orario_h1"
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  salvaOpH1(op: any){
    let data = {
      action: "crossover/crossover_bt",
      cmd: "salva_op_h1",
      ops: op
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  ultimoValore(mkt: string, ora: string){
    let data = {
      action: "crossover/crossover_bt",
      cmd: "ultimo_valore",
      market: mkt,
      ora: ora
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  listaMercati(){
    return super.getMarkets()
  }

  trade(op: any){
    let data = {
      action: "crossover/crossover_ts",
      cmd: "trade",
      market: op.market,
      verso: op.verso,
      stoploss: op.stoploss,
      takeprofit: op.takeprofit,
      oraopen: op.oraopen,
      oraclose: op.oraclose,
      prezzoopen: op.prezzoopen,
      prezzoclose: op.prezzoclose,
      profit: op.profit
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  listM15(numdati: number=500, pagina: number=0){
    let data = {
      action: "crossover/crossover_ts",
      cmd: "list_m15",
      numdati: numdati,
      pagina: pagina
    }
    return this.http.post(this.url, data, { headers: this.head })
  }
  
  listH4(numdati: number=500, pagina: number=0){
    let data = {
      action: "crossover/crossover_ts",
      cmd: "list_h4",
      numdati: numdati,
      pagina: pagina
    }
    return this.http.post(this.url, data, { headers: this.head })
  }
  
  listH1(numdati: number, pagina: number){
    let data = {
      action: "crossover/crossover_ts",
      cmd: "list_h1",
      numdati: numdati,
      pagina: pagina
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  aggiornaCross(){
    let data = {
      action: "crossover/crossover_ts",
      cmd: "aggiorna_cross"
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  aggiornaCrossH1(){
    let data = {
      action: 'crossover/crossover_ts',
      cmd: 'aggiorna_cross_h1'
    }
    return this.http.post(this.url, data, {headers: this.head})
  }

  aggiornaCrossH4(){
    let data = {
      action: 'crossover/crossover_ts',
      cmd: 'aggiorna_cross_h4'
    }
    return this.http.post(this.url, data, {headers: this.head})
  }

  valoriCambio(mkt: string, ora: string){
    let data = {
      action: "crossover/crossover_bt",
      cmd: "cambio",
      market: mkt,
      ora: ora
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  valoriCambioH1(mkt: string, ora: string){
    let data = {
      action: "crossover/crossover_bt",
      cmd: "cambio",
      timeframe: "h1",
      market: mkt,
      ora: ora
    }
    return this.http.post(this.url, data, { headers: this.head })
  }
  
  valoriCambioH4(mkt: string, ora: string){
    let data = {
      action: "crossover/crossover_bt",
      cmd: "cambio",
      timeframe: "h4",
      market: mkt,
      ora: ora
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  crossTimeframe(){
    let data = {
      action: "crossover/crossover_bt",
      cmd: "cross_timeframe"
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  xauM15(){
    let data = {
      action: "crossover/crossover_ts",
      cmd: "xau_m15"
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  xauH1(){
    let data = {
      action: "crossover/crossover_ts",
      cmd: "xau_h1"
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  xauM15_BT(){
    let data = {
      action: "crossover/crossover_bt",
      cmd: "xau_m15"
    }
    return this.http.post(this.url, data, { headers: this.head })
  }
  
  xauH1_BT(){
    let data = {
      action: "crossover/crossover_bt",
      cmd: "xau_h1"
    }
    return this.http.post(this.url, data, { headers: this.head })
  }
  
  getMarkets(): Observable<Object> {
    return super.getMarkets()
  }
}
